import React from "react";
import "./Verification/certificate-verification.css";

export default function PageHeading({ icon, title, subtitle, extra }) {
  return (
    <div className="cert-hero" style={{ marginBottom: 16 }}>
      <div className="cert-hero-inner">
        {icon && <div className="cert-hero-icon">{icon}</div>}
        <div style={{ flex: 1, minWidth: 220 }}>
          <h2 className="cert-hero-title">{title}</h2>
          {subtitle && <p className="cert-hero-sub">{subtitle}</p>}
        </div>
        {extra}
      </div>
    </div>
  );
}
